// Legacy title functions - now replaced by dynamic configuration in stepsConfig.js
// These are kept for backwards compatibility but should use the dynamic functions instead:
// - getStepTitle(stepsConfig, stepId) from stepsConfig.js  
// - getMainStepTitle(stepsConfig, mainStepId) from stepsConfig.js

export const getStepTitle = (stepId) => {
  console.warn('getStepTitle from stepHelpers is deprecated. Use getStepTitle from stepsConfig.js instead');
  return stepId;
};

export const getMainStepTitle = (mainStepId) => {
  console.warn('getMainStepTitle from stepHelpers is deprecated. Use getMainStepTitle from stepsConfig.js instead');
  return mainStepId;
};

// Update the steps array with current form state and validation
export const updateStepsArray = (stepsArray, formData, currentStep, completedSteps, getStepValidation) => {
  return stepsArray.map(step => {
    const updatedStep = { ...step };
    
    // Update active state
    updatedStep.active = step.id === currentStep || 
      (step.substeps && step.substeps.some(sub => sub.id === currentStep));
    
    // Update expanded state
    updatedStep.expanded = updatedStep.active || step.expanded;
    
    // Update completed state for main steps
    if (step.substeps) {
      // For steps with substeps, check if all substeps are completed AND valid
      updatedStep.complete = step.substeps.every(sub => {
        const isCompleted = completedSteps.includes(sub.id);
        const isValid = getStepValidation ? getStepValidation(sub.id).isValid : true;
        return isCompleted && isValid;
      });
      
      // Update substeps
      updatedStep.substeps = step.substeps.map(substep => {
        const isCompleted = completedSteps.includes(substep.id);
        const isValid = getStepValidation ? getStepValidation(substep.id).isValid : true;
        
        return {
          ...substep,
          active: substep.id === currentStep,
          complete: isCompleted && isValid
        };
      });
    } else {
      // For regular steps, check if completed AND valid
      const isCompleted = completedSteps.includes(step.id);
      const isValid = getStepValidation ? getStepValidation(step.id).isValid : true;
      updatedStep.complete = isCompleted && isValid;
    }
    
    return updatedStep;
  });
};